<template>
  <div class="maptoolscontainer">
    <ul>
      <li v-for="item in toolsData" :key="item.id" @click="clickTool(item)">
        <div class="icon"><img :src="item.img" alt="" /></div>
        <span class="li-span">{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
const fill = require('../../../static/image/analysis/面/fill_un.png');
const poly_un = require('../../../static/image/analysis/异形/poly_un.png');
const fenxi = require('../../assets/fenxi.png');
const remove = require('../../../static/image/analysis/删除/del_un.png');
import customConfig from 'customConfig';
import appConfig from 'appConfig';
export default {
  data() {
    return {
      toolsData: [
        { name: '多边形', id: '1', img: poly_un },
        { name: '矩形', id: '2', img: fill },
        { name: '清除', id: '3', img: remove },
        { name: '分析', id: '4', img: fenxi },
      ],
      draw: null,
      source: null,
      vector: null,
      drawFeature: null,
      wkt: null,
      layerQueryData: {},
      title: null,
    };
  },
  watch: {
    '$route.query.title': {
      handler() {
        // this.remove();
        this.title = null;
      },
    },
  },
  methods: {
    /**
     * @description: 创建图层
     * @Author: zjx
     * @Date: 2023-03-25 11:10:33
     * @return {*}
     */
    createdLayer() {
      const FILL_STYLE = new ol.style.Fill({ color: 'rgba(255, 255, 255, 0.2)' });
      const STROKE_STYLE = new ol.style.Stroke({ color: '#ffcc33', width: 2 });
      const CIRCLE_STYLE = new ol.style.Circle({
        radius: 7,
        fill: new ol.style.Fill({ color: '#ffcc33' }),
      });
      const style = new ol.style.Style({
        fill: FILL_STYLE,
        stroke: STROKE_STYLE,
        image: CIRCLE_STYLE,
      });
      this.source = new this.$olmap.source.Vector({ wrapX: false });
      this.vector = new this.$olmap.layer.Vector({
        source: this.source,
        id: 'Tyson111',
        zIndex: 3004,
        style,
      });
      this.olmap.addLayer(this.vector);
    },
    /**
     * @description: 选择地图上的工具栏
     * @Author: zjx
     * @Date: 2023-03-25 11:07:59
     * @param {*} v
     * @return {*}
     */
    clickTool(v) {
      const toolMap = { 1: this.polyUn, 2: this.fill, 3: this.remove, 4: this.analyse };
      const tool = toolMap[v.id];
      if (tool) {
        tool();
      }
    },
    polyUn() {
      if (this.draw != null) {
        this.draw.setActive(false);
      }
      try {
        let selectedFeatures = this.vector.getSource().getFeatures();
        // 假设我们需要删除第一个 feature
        let index = 0;
        let selectedFeature = selectedFeatures[index];
        // 从绘制图层中删除 feature
        this.vector.getSource().removeFeature(selectedFeature);
      } catch (error) {
        console.log(error);
      }
      this.draw = new this.$olmap.interaction.Draw({
        source: this.source,
        type: 'Polygon',
      });
      this.draw.on('drawend', (e) => {
        this.draw.setActive(false);
        // 获取绘制的 feature 对象
        let feature = e.feature;
        // 获取 feature 的 geometry 属性
        let geometry = feature.getGeometry();
        // 获取 feature 的点坐标数组
        let coordinates = geometry.getCoordinates()[0];
        // 将坐标数组转换成需要的格式，例如 WKT 格式
        this.wkt = new ol.format.WKT().writeGeometry(geometry);
      });
      this.olmap.addInteraction(this.draw);
    },
    async analyse() {
      const { layerInfo } = customConfig.themeService[this.$route.query.customId];
      this.layerQueryData.CqlFilter = this.wkt
        ? this.title
          ? `${layerInfo.wfs.keyFilds}='${this.title}' and INTERSECTS(the_geom,${this.wkt})`
          : `INTERSECTS(the_geom,${this.wkt})`
        : '';
      this.layerQueryData.where = this.wkt ? `INTERSECTS(the_geom,${this.wkt})` : '';
      this.layerQueryData.maxFeatures = 10;
      this.layerQueryData.startIndex = 0;
      this.layerQueryData.TypeName = layerInfo.layername;
      this.layerQueryData.SrsName = appConfig.map.proj;
      var TablepjsonResult = await this.publicMethod.geoServerQueryPost(
        layerInfo.url,
        this.layerQueryData,
        this.$olmap
      ); //通用查询方法

      this.$bus.emit('CultivatedLandWkt', this.wkt);
      if (TablepjsonResult.featureArr && TablepjsonResult.featureArr.length > 0) {
        if (this.wkt != null) {
          TablepjsonResult.wkt = this.wkt;
        }
      }
      this.$bus.emit('CultivatedLand', { data: TablepjsonResult, type: 'analyse' });
    },
    async remove() {
      const { layerInfo } = customConfig.themeService[this.$route.query.customId];
      try {
        let selectedFeatures = this.vector.getSource().getFeatures();
        // 假设我们需要删除第一个 feature
        let index = 0;
        let selectedFeature = selectedFeatures[index];
        // 从绘制图层中删除 feature
        this.vector.getSource().removeFeature(selectedFeature);
        this.$bus.emit('CultivatedLandTablePageNumber', { index: 1, type: 'remove' });
      } catch (error) {
        console.log(error);
      } finally {
        let mapData = JSON.parse(JSON.stringify(this.layerQueryData));
        mapData.id = '_layertree_:Tyson';
        mapData.url = layerInfo.url;
        mapData.layername = layerInfo.layername;
        let MappjsonResult = await this.publicMethod.createGeoServerWMS(this.$olmap, mapData, 9999);
        this.$bus.emit('CultivatedMap', { data: MappjsonResult, type: 'clear' });
        this.$emit('handlerClear');
        var source = this.olmap.zxQueryLayer.getSource();
        source.clear();
      }
    },
    fill() {
      if (this.draw != null) {
        this.draw.setActive(false);
      }
      try {
        let selectedFeatures = this.vector.getSource().getFeatures();
        // 假设我们需要删除第一个 feature
        let index = 0;
        let selectedFeature = selectedFeatures[index];
        // 从绘制图层中删除 feature
        this.vector.getSource().removeFeature(selectedFeature);
      } catch (error) {
        console.log(error);
      }
      var geometryFunction, maxPoints, value;
      value = 'LineString';
      maxPoints = 2;
      geometryFunction = function (coordinates, geometry) {
        if (!geometry) {
          //多边形
          geometry = new ol.geom.Polygon(null);
        }
        var start = coordinates[0];
        var end = coordinates[1];
        geometry.setCoordinates([[start, [start[0], end[1]], end, [end[0], start[1]], start]]);
        return geometry;
      };
      //实例化交互绘制类对象并添加到地图容器中
      this.draw = new this.$olmap.interaction.Draw({
        //绘制层数据源
        source: this.source,
        /** @type {ol.geom.GeometryType}几何图形类型 */
        type: value,
        //几何信息变更时调用函数
        geometryFunction,
        //最大点数
        maxPoints: maxPoints,
      });
      this.draw.on('drawend', (e) => {
        this.draw.setActive(false);
        // 获取绘制的 feature 对象
        let feature = e.feature;
        // 获取 feature 的 geometry 属性
        let geometry = feature.getGeometry();
        // 获取 feature 的点坐标数组
        let coordinates = geometry.getCoordinates()[0];
        // 将坐标数组转换成需要的格式，例如 WKT 格式
        this.wkt = new ol.format.WKT().writeGeometry(geometry);
      });
      this.olmap.addInteraction(this.draw);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.createdLayer();
    });
    this.$bus.off('CultivatedSetTitle');
    this.$bus.on('CultivatedSetTitle', (data) => {
      this.title = data;
    });
  },
};
</script>

<style lang="less" scoped>
.maptoolscontainer {
  position: absolute;
  top: 8rem;
  right: 1%;
  height: 34px;
  z-index: 99;
  font-size: 12px;
  line-height: 22px;
  // width: 300px;
  width: 30rem;
  // padding-left: 10px;
  // padding-right: 100px;
  text-align: center;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.15);
  ul {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-flow: row;
    align-content: center;
    margin-top: 0px;
    list-style: none;
    padding-inline-start: 0px;
    li {
      border-left: 1px #eee solid;
      padding-left: 6px;
      box-sizing: border-box;
      display: flex;
      img {
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        margin-right: 5px;
      }
      .li-span {
        display: inline-block;
        vertical-align: middle;
        font-family: MicrosoftYaHei;
        font-size: -1px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: -1px;
        color: #333;
      }
    }
    li:hover {
      cursor: pointer;
      span {
        color: #2facfb;
      }
    }

    li:first-child {
      border-left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CultivatedLandComponent/Tools.vue